import { Segment } from 'shared/segments-navigation/segment.interface';

export const brandInfoSegments: Array<Segment> = [
  {
    id: 'product-groups',
    title: 'Product Groups',
    circleIcon: false,
    active: false,
  },
  {
    id: 'market-copy',
    title: 'Market Copy',
    name: 'marketing',
    circleIcon: false,
    active: false,
  },
  {
    id: 'core',
    title: 'Core',
    circleIcon: false,
    active: false,
  },
  {
    id: 'price-sheets',
    title: 'Price Sheets',
    circleIcon: false,
    active: false,
  }
];
